enum InventoryActionEnum {
    ADD = "add",
    SUBTRACT = "subtract",
    REPLACE = "replace",
}

export default InventoryActionEnum;
